import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  mutation($dealerId: Int!) {\n    resetDealerPassword(dealerId: $dealerId)\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  mutation($dealerId: Int!, $input: EditDealerInput!) {\n    updateDealer(\n      dealerId: $dealerId,\n      input: $input\n    ) {\n      id\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  mutation($code: String!, $input: NewDealerInput!) {\n    createDealer(\n      code: $code,\n      input: $input\n    ) {\n      id\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import gql from 'graphql-tag';
export var createDealer = gql(_templateObject());
export var updateDealer = gql(_templateObject2());
export var resetDealerPassword = gql(_templateObject3());